import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { House, Truck, Plus, MapPin, DotsThreeOutline, SignOut, X } from "@phosphor-icons/react";

const TABS = [
  { to: "/app", label: "Home", icon: House, end: true, tid: "tab-home" },
  { to: "/app/loads", label: "Loads", icon: Truck, tid: "tab-loads", match: (p) => p.startsWith("/app/loads") && p !== "/app/loads/new" || p.startsWith("/app/vehicles") },
  null,
  { to: "/app/locations", label: "Locations", icon: MapPin, tid: "tab-locations" },
];
const TAB_PATHS = ["/app", "/app/loads", "/app/locations", "/app/loads/new"];

export default function BottomTabs({ items, onLogout }) {
  const [more, setMore] = useState(false);
  const { pathname } = useLocation();
  useEffect(() => { setMore(false); }, [pathname]);
  const extra = items.filter(it => !TAB_PATHS.includes(it.to));
  const moreActive = extra.some(it => pathname.startsWith(it.to));
  const tabCls = (active) => `flex-1 flex flex-col items-center justify-center gap-0.5 h-full text-[10px] font-bold uppercase tracking-wider transition-colors ${active ? "text-accent" : "text-white/70"}`;

  return <>
    {more && <div className="lg:hidden fixed inset-0 z-40 bg-black/50" onClick={() => setMore(false)} data-testid="more-backdrop"/>}
    {more && <div className="lg:hidden fixed inset-x-0 z-50 max-h-[70vh] overflow-y-auto bg-primary text-primary-foreground border-t-4 border-accent slide-up"
      style={{ bottom: "calc(4rem + env(safe-area-inset-bottom))" }} data-testid="more-sheet">
      <div className="flex items-center justify-between px-4 pt-3 pb-1">
        <span className="eyebrow opacity-70">More</span>
        <button onClick={() => setMore(false)} aria-label="Close" data-testid="btn-more-close" className="p-2 -mr-2"><X size={20}/></button>
      </div>
      <div className="grid grid-cols-3 gap-px bg-white/10">
        {extra.map(it => <NavLink key={it.to} to={it.to} data-testid={`m-${it.tid}`}
          className={({ isActive }) => `flex flex-col items-center justify-center gap-1.5 py-4 bg-primary text-[11px] font-bold uppercase tracking-wider ${isActive ? "text-accent" : ""}`}>
          <it.icon size={24}/> {it.label}
        </NavLink>)}
        <button onClick={onLogout} data-testid="m-logout" className="flex flex-col items-center justify-center gap-1.5 py-4 bg-primary text-[11px] font-bold uppercase tracking-wider">
          <SignOut size={24}/> Logout
        </button>
      </div>
    </div>}
    <nav className="lg:hidden fixed inset-x-0 bottom-0 z-50 bg-primary border-t border-white/10" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="bottom-tabs">
      <div className="flex items-stretch h-16">
        {TABS.map((t, i) => t ? (
          <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.tid}
            className={({ isActive }) => tabCls(t.match ? t.match(pathname) : isActive)}>
            <t.icon size={24} weight="bold"/> {t.label}
          </NavLink>
        ) : (
          <NavLink key="new" to="/app/loads/new" data-testid="tab-new" className="flex-1 flex items-center justify-center" aria-label="New load">
            <span className="-mt-6 w-14 h-14 bg-accent text-accent-foreground flex flex-col items-center justify-center shadow-lg border-4 border-primary transition-transform active:scale-95">
              <Plus size={24} weight="bold"/>
              <span className="text-[9px] font-black uppercase leading-none">New</span>
            </span>
          </NavLink>
        ))}
        <button onClick={() => setMore(m => !m)} data-testid="tab-more" className={tabCls(more || moreActive)}>
          <DotsThreeOutline size={24} weight="bold"/> More
        </button>
      </div>
    </nav>
  </>;
}
